import { Button, Modal } from "antd";
import { useHistory } from "react-router-dom";
import AuthHelper from "./helpers";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { afterExpiry, resetTimer, setShouldShowPrompt } from "redux/reducers/LoginTimeOutSlice";
import moment from "moment";
import { OUTSIDE_APP } from "utils/Actions";
import { useTranslation } from "react-i18next";

const TimeoutAlert: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const showPrompt = useAppSelector(state => state.loginTimeout.showPrompt);
  const isRunning = useAppSelector(state => state.loginTimeout.isRunning);
  const dispatch = useAppDispatch();
  let appInterval: NodeJS.Timeout;

  // after logout, auth, session_timeout and auth may not have been cleared properly, causing the problem in AUP-117 where user sees 'session expired' modal upon going to the login screen.
  const checkAuthValid = () => {
    const isAuthed = AuthHelper.isAuthed();
    const existingSessionExpireTime = localStorage.getItem(AuthHelper.SESSION_EXPIRE_TIME);
    const justBefore = moment().subtract(1, "seconds");
    const sessionValid = justBefore.isBefore(moment(existingSessionExpireTime));
    if (!sessionValid) {
      const path = history.location.pathname;
      if (OUTSIDE_APP.includes(path)) {
        AuthHelper.clearAuth();
      }
    }
    return isAuthed && sessionValid;
  };

  useEffect(() => {
    startInterval();
    if (checkAuthValid() && !isRunning) {
      // resets in redux state, makes isRunning = true.
      dispatch(resetTimer());
    }
    return () => clearInterval(appInterval);
  });

  function startInterval() {
    if (isRunning) {
      appInterval = setInterval(() => {
        const existingSessionExpireTime = localStorage.getItem(AuthHelper.SESSION_EXPIRE_TIME);
        // to move back 1 second deliberately, to make sure following check to pass
        const justBefore = moment().subtract(1, "seconds").format();
        const strLastAccessTimeInStorage = existingSessionExpireTime || justBefore;
        const lastAccessTimeInStorage = moment(strLastAccessTimeInStorage);
        if (lastAccessTimeInStorage.isBefore(moment())) {
          if (appInterval != undefined) {
            dispatch(setShouldShowPrompt(true));
            try {
              clearInterval(appInterval);
            } catch (e: any) {
              console.error("error:" + e);
            }
          }
        }
      }, 1000);
    }
  }

  const redirectToLogin = () => {
    dispatch(afterExpiry());
    AuthHelper.clearAuth();
    history.push("/");
  };

  const locationState = history.location.state as any;
  // Add any other instances which may prompt this to show.
  const disablePrompt = locationState?.disableTimeoutPrompt;

  return (
    <Modal
      open={showPrompt && !disablePrompt}
      title={t("sessionExpired.title")}
      footer={[
        <Button key="return" type="primary" onClick={redirectToLogin}>
          Return to landing page
        </Button>
      ]}
      closable={false}
    >
      {t("sessionExpired.desc")}
    </Modal>
  );
};
export default TimeoutAlert;
